import { Foreground } from '@front/sharedcomponents/Styles';
export var TableCellTextStyle;
(function (TableCellTextStyle) {
    TableCellTextStyle[TableCellTextStyle["Default"] = 0] = "Default";
    TableCellTextStyle[TableCellTextStyle["Positive"] = 1] = "Positive";
    TableCellTextStyle[TableCellTextStyle["Negative"] = 2] = "Negative";
    TableCellTextStyle[TableCellTextStyle["Long"] = 3] = "Long";
    TableCellTextStyle[TableCellTextStyle["Short"] = 4] = "Short";
    TableCellTextStyle[TableCellTextStyle["Symbol"] = 5] = "Symbol";
    TableCellTextStyle[TableCellTextStyle["Quantity"] = 6] = "Quantity";
})(TableCellTextStyle || (TableCellTextStyle = {}));
export const TableCellTextStyleClass = {
    [TableCellTextStyle.Default]: Foreground.Primary,
    [TableCellTextStyle.Positive]: Foreground.Positive,
    [TableCellTextStyle.Negative]: Foreground.Negative,
    [TableCellTextStyle.Long]: Foreground.Long,
    [TableCellTextStyle.Short]: Foreground.Short,
    [TableCellTextStyle.Symbol]: Foreground.PrimaryData,
    [TableCellTextStyle.Quantity]: Foreground.PrimaryData
};
